// eslint-disable-next-line
export type Constructor<T = {}> = new (...args: any[]) => T;
